<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-300 ease-out"
      enter-from-class="translate-y-full opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-full opacity-0"
    >
      <div
        v-if="showBanner"
        class="fixed bottom-0 inset-x-0 z-[9999] p-4 sm:p-6"
      >
        <div class="max-w-2xl mx-auto bg-surface-container rounded-2xl shadow-lg border border-outline-variant/20 p-5">
          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <div class="flex-1">
              <p class="text-body-medium text-on-surface">
                Utilizamos cookies esenciales para el funcionamiento de la aplicación. Consulta nuestra
                <NuxtLink to="/legal/cookies" class="text-primary hover:underline font-medium">política de cookies</NuxtLink>
                para más información.
              </p>
            </div>
            <div class="flex gap-2 flex-shrink-0">
              <button
                @click="accept"
                class="px-5 py-2.5 bg-primary text-on-primary text-label-large font-medium rounded-full hover:bg-primary/90 transition-colors"
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
const route = useRoute()
const showBanner = ref(false)

// El flujo cliente QR (/r/**) NO debe mostrar el cookie banner:
// 1. Las cookies que usa son técnicas (token de sesión en localStorage,
//    estrictamente necesarias para el funcionamiento). Bajo GDPR/LSSI no
//    requieren consentimiento explícito; basta con que la política esté
//    accesible (lo está en /legal/cookies, enlazada desde el footer del
//    flujo cliente).
// 2. En móviles cortos (iPhone SE, Galaxy Fold, landscape de cualquier
//    móvil) el banner ocupaba más de la mitad del viewport y tapaba
//    físicamente el botón "Entrar" de la pantalla del nombre → el cliente
//    no podía siquiera abrir la sesión.
// 3. En las páginas con bottom-nav (carta/pedido/cuenta) el banner tapaba
//    el nav.
// Conclusión: para el cliente del bar el banner es ruido inútil.
const isClienteRoute = computed(() => route.path.startsWith('/r/'))

onMounted(() => {
  if (isClienteRoute.value) return
  const consent = localStorage.getItem('cookie-consent')
  if (!consent) {
    showBanner.value = true
  }
})

function accept() {
  localStorage.setItem('cookie-consent', 'accepted')
  showBanner.value = false
}
</script>
